module.exports = __webpack_public_path__ + "img/to_rechargepray_kr.9398a436.png";